import { useState } from "react";
import { ANY, WATER_LEVELS, hasBeachFilters } from "@/data/beachFilters";

const labelCls = "text-[9.5px] tracking-[0.14em] uppercase font-black text-[#9CA3AF]";

/**
 * Beach finder: the search box stands on its own, and the three guide
 * dropdowns — activity, water, nearby — fold away behind one bar so the
 * beaches themselves sit right under it. The bar names whatever is chosen, so
 * a collapsed guide never hides an active filter.
 */
export default function BeachFinder({ filters, onChange, matchCount, total }) {
  const [open, setOpen] = useState(false);
  const set = (patch) => onChange({ ...filters, ...patch });
  const active = hasBeachFilters(filters);

  const chosen = [
  filters.activity !== ANY ? filters.activity : null,
  filters.water !== ANY ? WATER_LEVELS.find((l) => l.value === filters.water)?.label : null,
  filters.nearby !== ANY ? filters.nearby : null].
  filter(Boolean);

  return null;

































































































}